export const throwError = (error: string) => {
    throw new Error(error);
};
